var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"onboarding-paragraph"},[_vm._v("\n  Later you can use our dream and goal templates, but right now take your time and create your own motivating and ambitious dream. Nothing is set in stone, your dreams will develop in the same way as you do.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }